import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';

@Component({
    selector: 'app-home-services',
    standalone: true,
    imports: [CommonModule, TranslateModule, RouterModule, SlickCarouselModule],
    templateUrl: './home-services.component.html',
    styleUrl: './home-services.component.scss',
})
export class HomeServicesComponent {
    slideConfig = {
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                },
            },
        ],
    };
}
